var _circle, _circle2, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmolLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3C404A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 19.9999,
    r: 19.5292,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 19.9999,
    r: 19.5292,
    fill: "#5F6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3218 20.5057C5.42439 20.2404 -4.99316 29.1067 -4.99316 29.1067L-2.36229 45.3979H41.2496V16.2559C41.2496 16.2559 37.1672 20.2539 33.9575 21.8717C32.3702 22.6718 30.1859 23.2982 28.3891 23.7261C26.299 24.2238 24.1268 23.8256 22.1557 22.9705C19.6892 21.9004 16.1484 20.6007 13.3218 20.5057Z",
    fill: "#E4E9F2",
    stroke: "#E4E9F2",
    strokeWidth: 0.202375
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9343 17.453C28.4528 16.6406 30.6467 13.1298 29.8343 9.61121C29.022 6.09266 25.5111 3.89883 21.9926 4.71115C21.0514 4.92843 20.2051 5.33877 19.4857 5.89069C22.5914 5.33594 25.6193 7.31026 26.3369 10.4187C27.0545 13.5271 25.1986 16.6289 22.1641 17.4918C23.0526 17.6724 23.9932 17.6702 24.9343 17.453Z",
    fill: "#F1AC49"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmolLogo);
export default __webpack_public_path__ + "static/media/amol-logo.d91f0b680afd35a7f41ab8cae2fa924c.svg";
export { ForwardRef as ReactComponent };